"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseWearable = void 0;
const validation_1 = require("../../validation");
const wearable_category_1 = require("../../dapps/wearable-category");
const i18n_1 = require("./i18n");
const representation_1 = require("./representation");
const metrics_1 = require("./metrics");
const displayable_1 = require("../shared/displayable");
/** @alpha */
var BaseWearable;
(function (BaseWearable) {
    BaseWearable.schema = {
        type: 'object',
        properties: {
            ...displayable_1.displayableProperties,
            id: {
                type: 'string'
            },
            descriptions: {
                type: 'array',
                items: i18n_1.I18N.schema,
                minItems: 1
            },
            names: {
                type: 'array',
                items: i18n_1.I18N.schema,
                minItems: 1
            },
            data: {
                type: 'object',
                properties: {
                    replaces: {
                        type: 'array',
                        items: wearable_category_1.WearableCategory.schema
                    },
                    hides: {
                        type: 'array',
                        items: wearable_category_1.WearableCategory.schema
                    },
                    tags: {
                        type: 'array',
                        items: {
                            type: 'string',
                            minLength: 1
                        }
                    },
                    representations: {
                        type: 'array',
                        items: representation_1.WearableRepresentation.schema,
                        minItems: 1
                    },
                    category: wearable_category_1.WearableCategory.schema
                },
                additionalProperties: false,
                required: ['replaces', 'hides', 'tags', 'representations', 'category']
            },
            thumbnail: {
                type: 'string'
            },
            image: {
                type: 'string'
            },
            metrics: {
                ...metrics_1.Metrics.schema,
                nullable: true
            }
        },
        additionalProperties: false,
        required: ['id', 'descriptions', 'names', 'data', 'thumbnail', 'image']
    };
    // Returns true only if there are no entries with the same locale
    BaseWearable.validateDuplicatedLocales = (i18ns) => i18ns.every(({ code }, index) => i18ns.findIndex((i18n) => i18n.code === code) === index);
    const schemaValidator = (0, validation_1.generateValidator)(BaseWearable.schema);
    BaseWearable.validate = (wearable) => schemaValidator(wearable) &&
        BaseWearable.validateDuplicatedLocales(wearable.descriptions) &&
        BaseWearable.validateDuplicatedLocales(wearable.names);
})(BaseWearable = exports.BaseWearable || (exports.BaseWearable = {}));
//# sourceMappingURL=base-wearable.js.map